import { COLORS } from '@btime/constants'
import { formatAddressToObj } from '@btime/helpers'
import PlacesAutocomplete from 'react-places-autocomplete'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Absolute } from '../helpers/Position'
import { SmallText, Text } from '../presentation/Text'
import { getAddressFromGoogleApi } from '../../utils/helpers/address'
import { useGooglePlacesScript } from '../../utils/hooks/scripts'
import ErrorHandler from '../helpers/ErrorHandler'
import FlexGrid, { FlexCol } from '../structure/FlexGrid'
import Input from './Input'
import InputWrapper from './InputWrapper'
import Loading from '../helpers/Loading'
import Menu, { MenuItem } from '../navigation/Menu'
import Panel from '../structure/Panel'
import { Relative } from '../../packages/kiti/components/helpers/Position'

const GoogleMapsErrorMessage = ({ error }) => {
  const { t } = useTranslation('components')

  return (
    <div>
      <Text color={COLORS.red}>{t('errorLoadingGoogleMaps')}</Text>
      <SmallText>{error && error.message}</SmallText>
    </div>
  )
}

const AddressInput = ({ onChange, value, disabled, ...props }) => {
  const { t } = useTranslation('components')
  const [loading, error] = useGooglePlacesScript()

  value = formatAddressToObj(value)

  const [search, setSearch] = useState(value.search || '')

  if (!!error) return <GoogleMapsErrorMessage />
  if (!!loading) return <Loading />

  const onSelect = async (search, placeId) => {
    const formattedAddress = await getAddressFromGoogleApi(placeId)
    onChange({ ...value, ...formattedAddress, search })
    setSearch(search)
  }

  const onChangeComplement = complement => {
    onChange({ ...value, complement })
  }

  return (
    <ErrorHandler FallbackComponent={GoogleMapsErrorMessage}>
      <Relative zIndex="auto">
        <FlexGrid gutter={0.2} align="flex-start">
          <FlexCol flex={3}>
            <PlacesAutocomplete value={search} onChange={setSearch} onSelect={onSelect} debounce={900}>
              {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                <div>
                  <InputWrapper {...props} disabled={disabled}>
                    <input
                      {...getInputProps({
                        className: 'input',
                        disabled
                      })}
                    />
                  </InputWrapper>
                  {!disabled && (
                    <Absolute zIndex={100}>
                      <Panel noPadding noMargin>
                        <Menu>
                          {loading ? (
                            <Loading />
                          ) : (
                            suggestions.map((suggestion, index) => (
                              <div key={suggestion.id + index} {...getSuggestionItemProps(suggestion)}>
                                <MenuItem focus={suggestion.active}>{suggestion.description}</MenuItem>
                              </div>
                            ))
                          )}
                        </Menu>
                      </Panel>
                    </Absolute>
                  )}
                </div>
              )}
            </PlacesAutocomplete>
          </FlexCol>
          <FlexCol flex={1}>
            <Input
              placeholder={t('complementOptional')}
              value={value.complement || ''}
              onStopTyping={onChangeComplement}
              disabled={!value.search}
            />
          </FlexCol>
        </FlexGrid>
      </Relative>
    </ErrorHandler>
  )
}

export default AddressInput
